/**
 * Lynden DEV — cart qty helpers (pages v2)
 */
(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function moneyFromCents(cents, format) {
    // best-effort fallback if Shopify.formatMoney missing
    if (window.Shopify && typeof Shopify.formatMoney === "function" && format) {
      return Shopify.formatMoney(cents, format);
    }
    var n = (Number(cents) / 100).toFixed(2).replace(".", ",");
    return n + " €";
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: "same-origin",
    }).then(function (r) {
      if (!r.ok) throw new Error("cart change failed");
      return r.json();
    });
  }

  function wireCart(root) {
    if (!root) return;
    var busy = false;

    function setBusy(on) {
      busy = on;
      root.classList.toggle("is-busy", on);
      root.querySelectorAll("button, input").forEach(function (el) {
        if (el.closest("[data-lyd-checkout]")) return;
        if (on) el.setAttribute("disabled", "disabled");
        else el.removeAttribute("disabled");
      });
    }

    function reload() {
      window.location.reload();
    }

    root.querySelectorAll("[data-lyd-qty]").forEach(function (wrap) {
      var key = wrap.getAttribute("data-line-key");
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector("[data-lyd-qty-minus]");
      var plus = wrap.querySelector("[data-lyd-qty-plus]");
      if (!key || !input) return;

      function apply(q) {
        q = Math.max(0, parseInt(q, 10) || 0);
        if (busy) return;
        setBusy(true);
        changeLine(key, q)
          .then(function () {
            reload();
          })
          .catch(function () {
            setBusy(false);
            reload();
          });
      }

      if (minus) {
        minus.addEventListener("click", function () {
          apply((parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (plus) {
        plus.addEventListener("click", function () {
          apply((parseInt(input.value, 10) || 0) + 1);
        });
      }
      input.addEventListener("change", function () {
        apply(input.value);
      });
    });

    root.querySelectorAll("[data-lyd-remove]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var key = btn.getAttribute("data-line-key");
        if (!key || busy) return;
        setBusy(true);
        changeLine(key, 0)
          .then(function () {
            reload();
          })
          .catch(function () {
            setBusy(false);
            reload();
          });
      });
    });
  }

  function wireAuth(root) {
    if (!root) return;
    var login = root.querySelector("[data-lyd-login-panel]");
    var recover = root.querySelector("[data-lyd-recover-panel]");
    var toRecover = root.querySelectorAll("[data-lyd-show-recover]");
    var toLogin = root.querySelectorAll("[data-lyd-show-login]");
    if (!login || !recover) return;

    function showRecover(on) {
      if (on) {
        login.classList.add("is-hidden");
        recover.classList.add("is-visible");
        var first = recover.querySelector("input");
        if (first) first.focus();
      } else {
        login.classList.remove("is-hidden");
        recover.classList.remove("is-visible");
      }
      if (on && window.location.hash !== "#recover") {
        history.replaceState(null, "", "#recover");
      } else if (!on && window.location.hash === "#recover") {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      }
    }

    toRecover.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        showRecover(true);
      });
    });
    toLogin.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        showRecover(false);
      });
    });

    if (window.location.hash === "#recover") showRecover(true);
  }

  ready(function () {
    document.querySelectorAll("[data-lyd-cart]").forEach(wireCart);
    document.querySelectorAll("[data-lyd-auth]").forEach(wireAuth);
  });
})();
